import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import { connect } from "react-redux";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { onBoardingActions } from "../../actions/onBoardingActions";
import api from "../../api/onBoarding.resource";
import {
  DECLARATION_PLACES,
  defaultToastOptions,
  alphaNumericWithSpacePattern,
  alphaNumericWithSpecialCharacterPattern,
  LAPTOP_TYPES,
  EMPLOYEE_TYPES,
  ONBOARDING_TYPES
} from "../../constants/constants";
import useValidation from "../../util/useValidation";
import { getFormattedDate } from "../../util/helpers";

const ITSetup = ({ onClose, selectedUser }) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const [candidateDetails, setCandidateDetails] = useState({ userDetails: {} });
  const itSetUpForm = useRef(null);
  // const [isValid, setIsValid] = useState(false);
  const {
    firstName,
    middleName,
    lastName,
    emailId,
    contactNumber,
    cDKDesignation,
    cDKEmployeeType,
    reportingManagerName,
    reportingManagerEmail,
    dateofJoining,
    declarationPlace,
    project,
    recruiter,
    lapTopType,
    onboardingType
  } = candidateDetails.userDetails;

  // const isValidUserData = () =>
  //   itSetUpForm.current && itSetUpForm.current.checkValidity();
  // useEffect(() => {
  //   setIsValid(isValidUserData());
  // });

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    const res = await api.getPersonalDetails(selectedUser.id);
    setCandidateDetails(res);
  };

  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  const handleOnChangeInput = e => {
    const { name, value } = e.target;
    setCandidateDetails(prevState => ({
      ...prevState,
      userDetails: { ...prevState.userDetails, [name]: value }
    }));
  };

  const handleOnSubmit = async () => {
    toast.configure();
    try {
      const res = await api.saveOnBoardingDetails(candidateDetails);
      if (res && !res.errorMessage) {
        toast.success("Saved Successfully ", defaultToastOptions);
      } else {
        toast.error(`Error while Saving Details`, defaultToastOptions);
      }
    } catch (e) {
      toast.error(`Error while Saving Details`, defaultToastOptions);
    }
    onClose();
  };
  return (
    <Modal
      show
      onHide={onClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-width"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Information for IT Team</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form ref={itSetUpForm}>
          <div className="d-flex flex-column mx-5 mb-3 border-bottom">
            <Row className="py-3">
              <Col sm={2} className="text-right">
                <b>First Name : </b>
              </Col>
              <Col sm={5}>
                {[firstName, middleName].filter(n => n).join(" ")}
              </Col>
              <Col sm={2} className="text-right">
                <b>Last Name :</b>
              </Col>
              <Col sm={3}>{lastName}</Col>
            </Row>
            <Row className="pb-3">
              <Col sm={2} className="text-right">
                <b>Email Id :</b>
              </Col>
              <Col sm={5}>{emailId}</Col>
              <Col sm={2} className="text-right">
                <b>Contact No :</b>
              </Col>
              <Col sm={3}>{contactNumber}</Col>
            </Row>
          </div>

          <Form.Group as={Row}>
            <Form.Label as="legend" column sm={3} className="text-right">
              Designation
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                size="sm"
                type="text"
                placeholder="Designation"
                name="cDKDesignation"
                required
                value={cDKDesignation}
                onChange={handleOnChangeInput}
                pattern={alphaNumericWithSpecialCharacterPattern}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.cDKDesignation}
              />
              {errors.cDKDesignation && (
                <Form.Control.Feedback type="invalid">
                  {errors.cDKDesignation.type === "required" &&
                    "Designation is required"}
                  {errors.cDKDesignation.type === "pattern" &&
                    "Invalid characters entered for Designation"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label as="legend" column sm={3} className="text-right">
              Reporting Manager
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                type="text"
                placeholder="Reporting Manager"
                size="sm"
                name="reportingManagerName"
                required
                value={reportingManagerName}
                onChange={handleOnChangeInput}
                pattern={alphaNumericWithSpacePattern}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.reportingManagerName}
              />
              {errors.reportingManagerName && (
                <Form.Control.Feedback type="invalid">
                  {errors.reportingManagerName.type === "required" &&
                    "Reporting Manager is required"}
                  {errors.reportingManagerName.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label as="legend" column sm={3} className="text-right">
              Reporting Manager Email
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                type="text"
                placeholder="Reporting Manager Email"
                size="sm"
                name="reportingManagerEmail"
                required
                value={reportingManagerEmail}
                onChange={handleOnChangeInput}
                //pattern={alphaNumericWithSpacePattern}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.reportingManagerEmail}
              />
              {errors.reportingManagerEmail && (
                <Form.Control.Feedback type="invalid">
                  {errors.reportingManagerEmail.type === "required" &&
                    "Reporting Manager Email is required"}
                  {errors.reportingManagerEmail.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={3} className="text-right">
              Joining Date
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                size="sm"
                type="date"
                name="dateofJoining"
                required
                value={getFormattedDate(dateofJoining, undefined, "YYYY-MM-DD")}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.dateofJoining}
              />
              {errors.dateofJoining && (
                <Form.Control.Feedback type="invalid">
                  {errors.dateofJoining.type === "required" &&
                    "Joining Date is required"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={3} className="text-right">
              Work Location
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                size="sm"
                as="select"
                name="declarationPlace"
                required
                value={declarationPlace}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.declarationPlace}
              >
                <option value="">Choose...</option>
                {DECLARATION_PLACES.map(loc => (
                  <option value={loc.id}>{loc.name}</option>
                ))}
              </Form.Control>

              {errors.declarationPlace && (
                <Form.Control.Feedback type="invalid">
                  {errors.declarationPlace.type === "required" &&
                    "Work Location is required"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={3} className="text-right">
              Project
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                size="sm"
                type="text"
                name="project"
                placeholder="Project"
                required
                value={project}
                onChange={handleOnChangeInput}
                pattern={alphaNumericWithSpacePattern}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.project}
              />
              {errors.project && (
                <Form.Control.Feedback type="invalid">
                  {errors.project.type === "required" && "Project is required"}
                  {errors.project.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={3} className="text-right">
              Recruiter
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                size="sm"
                type="text"
                name="recruiter"
                placeholder="Recruiter"
                required
                value={recruiter}
                onChange={handleOnChangeInput}
                pattern={alphaNumericWithSpacePattern}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.recruiter}
              />
              {errors.recruiter && (
                <Form.Control.Feedback type="invalid">
                  {errors.recruiter.type === "required" &&
                    "Recruiter is required"}
                  {errors.recruiter.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={3} className="text-right">
              Laptop Type
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                size="sm"
                as="select"
                name="lapTopType"
                required
                value={lapTopType}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.lapTopType}
              >
                <option value="">Choose...</option>
                {LAPTOP_TYPES.map(i => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </Form.Control>
              {errors.lapTopType && (
                <Form.Control.Feedback type="invalid">
                  {errors.lapTopType.type === "required" &&
                    "Laptop is required"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={3} className="text-right">
              Contract/Permanent/Intern
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                size="sm"
                as="select"
                name="cDKEmployeeType"
                required
                value={cDKEmployeeType}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.cDKEmployeeType}
              >
                <option value="">Choose...</option>
                {EMPLOYEE_TYPES.map(i => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </Form.Control>
              {errors.cDKEmployeeType && (
                <Form.Control.Feedback type="invalid">
                  {errors.cDKEmployeeType.type === "required" &&
                    "Contractor/Permanent is required"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={3} className="text-right">
              Onboarding Process
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                size="sm"
                as="select"
                required
                name="onboardingType"
                value={onboardingType}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                //isInvalid={errors.onboardingType}
              >
                <option value="">Choose...</option>
                {ONBOARDING_TYPES.map(i => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </Form.Control>
              {errors.onboardingType && (
                <Form.Control.Feedback type="invalid">
                  {errors.onboardingType.type === "required" &&
                    "Onboarding Process is required"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleOnSubmit}
          //disabled={!isValid}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
const mapStateToProps = ({ onBoardingDetails }) => ({
  generalDetails: onBoardingDetails.generalDetails || {},
  personalDetails: onBoardingDetails.personalDetails || {}
});

const mapDispatchToProps = {
  getPersonalDetails: onBoardingActions.getPersonalDetails
};
export default connect(mapStateToProps, mapDispatchToProps)(ITSetup);
